import { z } from 'zod'

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message
  } else if (typeof error === 'string') {
    return error
  } else {
    const parsedAsObject = z
      .union([
        z.object({ message: z.string() }),
        z.object({ error: z.string() }),
        z.object({ detail: z.string() }),
      ])
      .safeParse(error)
    if (parsedAsObject.success) {
      const { data } = parsedAsObject
      // @ts-ignore
      return data.message ?? data.error ?? data.detail ?? 'Unknown error'
    }
    return 'Unknown error'
  }
}
